import React from 'react';
import { connect } from 'react-redux';
import { InputRating } from '@treelab/panda';
// @ts-ignore

import { IRootState } from '../../../../modules/stores';
import { isAbsentCellValue } from '../../../../helpers';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string; // Same deal. If this is passed here, it means the table element is using.
}

const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  if (isAbsentCellValue(cell) || !field) return null;

  return (
    <InputRating
      input={{ name: field.id, value: cell }}
      ratingMax={field.typeOptions.ratingMax}
      isDisabled
      meta={{}}
    />
  );
};

const mapState = ({ core }: IRootState, { fieldId, recordId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
});

export default {
  WithFieldId: connect(mapState)(WithFieldId),
  // Raw for Lookup not implemented until later
};
